import React, { Component } from "react";

const url = process.env.REACT_APP_KBANK_GATEWAY_URL;

let created = false;
let submitTimeout = null;

class KbankButton extends Component {
  static defaultProps = {
    action: `${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/creditcard/main/website`,
    apikey: process.env.REACT_APP_KBANK_PUBLIC_KEY,
    amount: "100.00",
    currency: "THB",
    paymentMethods: "card",
    name: "Tiffany",
    description: "Tiffany Ticket",
    onError: () => null,
    mid: process.env.REACT_APP_KBANK_WECHAT_MERCHANT_ID,
    // mid: null,
    orderId: null,
    submit: false,
  };

  constructor(props) {
    super(props);
    this.instance = React.createRef();
  }

  componentDidMount() {
    this.init();
    const { submit } = this.props;
    if (submit) {
      setTimeout(() => {
        this.submit();
      }, 1000);
    }
  }

  componentWillUnmount() {
    clearTimeout(submitTimeout);
  }

  submit = () => {
    // const { id } = this.props;
    // const form = document.getElementById(id);
    // const kbankButton = form.querySelector(".pay-button");
    console.log('submit ::', this.props);
    const kbankButton = document.querySelector(".pay-button");

    if (kbankButton) {
      console.log("kbankButton - submit IF", kbankButton);
      kbankButton.click();
    } else {
      console.log("kbankButton - submit ELSE");
      submitTimeout = setTimeout(() => {
        this.submit();
      }, 1000);
    }
  };

  init = () => {
    const {
      apikey,
      amount,
      currency,
      paymentMethods,
      name,
      description,
      mid,
      orderId,
    } = this.props;
    const s = document.createElement("script");
    s.setAttribute("type", "text/javascript");
    s.setAttribute("src", url);
    s.setAttribute("data-apikey", apikey);
    s.setAttribute("data-amount", amount);
    s.setAttribute("data-currency", currency);
    s.setAttribute("data-payment-methods", paymentMethods);
    s.setAttribute("data-name", name);
    s.setAttribute("data-description", description);
    if (mid) s.setAttribute("data-mid", mid);
    if (orderId) s.setAttribute("data-order-id", orderId);
    s.addEventListener("load", function () {
      if (!created) {
        KPayment.create(); // eslint-disable-line
        created = true;
      }
    });
    s.addEventListener("error", function (e) {
      this.props.onError(e);
    });
    this.instance.current.appendChild(s);
  };

  render() {
    const {
      id,
      action,
      authToken,
      amount,
      currency,
      paymentMethods,
      name,
      description,
      ShowDate,
      ShowTimeID,
      BookingSeat,
      DrinkDinner,
      customerName,
      customerPhone,
      customerEmail,
      invoiceName,
      invoiceAddress,
      invoicePhone,
      taxId,
      invoiceEmail,
      branchTax,
    } = this.props;
    if (created) {
      // eslint-disable-next-line
      KPayment.configure({
        amount,
        currency,
        paymentMethods,
        name,
        description,
      });
    }
    // console.log("KbankButton ::", id, this.instance);
    return (
      <form
        id={id}
        className="kbank-form"
        method="POST"
        action={action}
        style={{ display: "none" }}
      >
        <input type="hidden" name="authToken" value={authToken} />
        <input type="hidden" name="amount" value={amount} />
        <input type="hidden" name="currency" value={currency} />
        <input type="hidden" name="description" value={description} />
        <input type="hidden" name="ShowDate" value={ShowDate} />
        <input type="hidden" name="ShowTimeID" value={ShowTimeID} />
        <input type="hidden" name="BookingSeat" value={BookingSeat} />
        <input type="hidden" name="DrinkDinner" value={DrinkDinner} />
        <input type="hidden" name="customerName" value={customerName} />
        <input type="hidden" name="customerPhone" value={customerPhone} />
        <input type="hidden" name="customerEmail" value={customerEmail} />
        <input type="hidden" name="invoiceName" value={invoiceName} />
        <input type="hidden" name="invoiceAddress" value={invoiceAddress} />
        <input type="hidden" name="invoicePhone" value={invoicePhone} />
        <input type="hidden" name="taxId" value={taxId} />
        <input type="hidden" name="invoiceEmail" value={invoiceEmail} />
        <input type="hidden" name="branchTax" value={branchTax} />
        <div className="instance" ref={this.instance} />
      </form>
    );
  }
}

export default KbankButton;



// WEBPACK FOOTER //
// ./src/components/KbankButton.js